import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-resources',
    templateUrl: './resources.component.html',
    styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent implements OnInit {

    allBlogArticles = [
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/z5gbTECy1i8VdjyJ5Tzhm8KSJwKQSxLtvoKTD9fn.jpg',
            title: 'Best All-in-One PC in India | Manufacturer & Provider – VIRSA',
            summary: 'Looking for the best All-in-One PC in India? Explore VIRSA All-in-One PCs with Intel processor options, Full HD displays, expandable RAM, SSD storage, and modern connectivity.',
            link: '/blog/best-all-in-one-pc-manufacturer-india'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/JjtyT7Y8SKKCPRU1ZJeRjCu2uX7sF5ZjUcuGbWfS.jpg',
            title: 'Best IFP Protection Sliding Shutters in India | VIRSA',
            summary: 'Looking for the best IFP protection sliding shutter in India? VIRSA offers heavy-duty metal shutters with key-lock security, smooth sliding rails, and customizable writing and notice boards.',
            link: '/blog/best-ifp-protection-sliding-shutter-india'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/b9Sw6IMpwdrfBH8LedeFdOMkjsI5RmCSXweISGKk.jpg',
            title: 'Best Learning Management System (LMS) in India | VIRSA',
            summary: 'Explore VIRSA LMS for AI-powered learning assistance, digital learning, assessments and institutional academic workflows for schools and colleges in India.',
            link: '/blog/best-learning-management-system-india'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/bl3uWYd8LY5dgGPa0A3JDmI2GeYFzxpWP0LWQljh.jpg',
            title: 'Best K–12 Digital Content in India | VIRSA K–12 Content',
            summary: 'Explore VIRSA K–12 Digital Content with curriculum-aligned lessons, animated concept videos, assessments and worksheets for modern schools and smart classrooms.',
            link: '/blog/best-k12-digital-content-india'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/lgjDDu3l1JPSxdgdMa73cDbygJsHFPPWPHWnsWAb.jpg',
            title: 'Best Interactive Flat Panel Company in India: VIRSA Smart Board & Digital Board Solutions',
            summary: 'Looking for the best Interactive Flat Panel, Smart Board or Digital Board company in India? Explore VIRSA Interactive Flat Panels for schools, colleges, universities and institutions.',
            link: '/blog/best-interactive-flat-panel-company-in-india'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/xnfLptWq7tP6Nh9lANJVrJBD6sPzEXLKDZQj87qX.jpg',
            title: 'Beyond the Traditional Blackboard: The Era of Interactive Learning',
            summary: 'Discover how Virsa Interactive Flat Panels and digital learning tools are transforming traditional classrooms into interactive learning environments with VIRSA smart classroom solutions.',
            link: '/blog/beyond-traditional-blackboard-era-of-interactive-learning'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/QTTVmvRcWerZSplBCqmWlWCzv3VMkQyIXLBA92tD.jpg',
            title: 'How Institutions Can Digitize Attendance, Exams and Homework Using VIRSA LMS',
            summary: 'Learn how schools and educational institutions can digitize attendance, exams, homework, assessments and student performance tracking using the VIRSA Learning Management System.',
            link: '/blog/digitize-attendance-exams-homework-using-lms'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/LS9Wn5SPV7yHZazcgREArs49LH7GJqbsIFlj9Gq6.jpg',
            title: 'NCERT-Aligned Digital K–12 Content: What Schools Should Know',
            summary: 'Understand how NCERT-aligned digital K–12 content supports curriculum-based learning, interactive teaching, assessments, and better classroom engagement. Explore VIRSA digital learning content for schools.',
            link: '/blog/ncert-aligned-digital-k12-content-what-schools-should-know'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/BBZARu9ovuSP0WgxETFIKScFQcda4LtreOtIzkN7.jpg',
            title: 'How to Choose an OPS for an Interactive Flat Panel: Complete Guide for Schools & Institutions',
            summary: 'Learn how to choose the right OPS for an Interactive Flat Panel. Compare processor, RAM, SSD storage, graphics, connectivity, compatibility, upgradeability and performance with VIRSA OPS solutions.',
            link: '/blog/how-to-choose-an-ops-for-an-interactive-flat-panel'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/OtrK1pl9tIKwku39rb0G63JDWitJvr2Q0k4JfKUb.jpg',
            title: 'Benefits of Lockable IFP Protection Shutters for Schools | VIRSA IFP Safety Solutions',
            summary: 'Discover the benefits of lockable IFP protection shutters for schools. Protect Interactive Flat Panels from damage, dust, and unauthorized access with VIRSA IFP Sliding Shutters.',
            link: '/blog/benefits-of-lockable-ifp-protection-shutters'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/MvEhkXCAqa1HdByZj9mtEb2LtTfGtRnzL2rvIYgW.jpg',
            title: 'Best All-in-One PCs for Coding, STEM & Skill Development Labs VIRSA',
            summary: 'Discover how VIRSA All-in-One PCs help schools, colleges, STEM labs, coding classrooms, and skill development centers create modern, high-performance digital learning environments.',
            link: '/blog/all-in-one-pcs-for-coding-stem-skill-development-labs'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/p7MKCP2K1lGm05dfYR1x9BXv24JxgoGLi4YPG8lv.jpg',
            title: 'How Virsa Smart Classroom Solutions Help Schools Increase Admissions in 2026 | VIRSA',
            summary: 'Discover how VIRSA Smart Classroom Solutions help schools improve admissions through interactive classrooms, AI-powered learning, digital infrastructure, and modern teaching technology.',
            link: '/blog/how-smart-classroom-solutions-help-schools-increase-admissions'
        },

        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/8TL3nymTHs8urFrd8w5s0iD6aybiK6oZtZs1rCzK.jpg',
            title: 'The Role of Interactive Flat Panels in Remote Work & Hybrid Collaboration | VIRSA',
            summary: 'Discover how VIRSA Interactive Flat Panels improve remote work, hybrid meetings, online collaboration, virtual training, and digital communication for businesses and institutions.',
            link: '/blog/role-of-interactive-flat-panels-in-remote-work'
        },

        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/fkeTLOQaaJ3kg66kEQPKNgj6JYvAPAbp7Uohb0T4.jpg',
            title: 'Find the Perfect IFP Size for Your Campus | VIRSA Interactive Flat Panels',
            summary: 'Find the perfect Interactive Flat Panel size for your campus. Compare 75”, 86”, 98”, and 105” VIRSA IFPs for classrooms, lecture halls, seminar rooms, and smart campuses.',
            link: '/blog/find-the-perfect-ifp-size-for-your-campus'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/8U8gdu1JAluHRFcWbRzVNAZam9tPj5bajmvJiIu0.jpg',
            title: 'Become a VIRSA Channel Partner, Dealer & Distributor in India',
            summary: 'Join VIRSA as a channel partner, dealer, or distributor for smart classroom and EdTech solutions. Grow your business with high-demand education technology products.',
            link: '/blog/become-virsa-channel-partner-distributor'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/4WHjl90Mh33dZwEafRgy2WeHQhT5952sNeSSVs2a.jpg',
            title: 'VIRSA Android 16 Interactive Flat Panels — Built for the Classrooms of Tomorrow',
            summary: 'Discover VIRSA Android 16 Interactive Flat Panels with AI-powered teaching tools, DDR5 performance, multi-touch interaction, and smart classroom integration.',
            link: '/blog/virsa-android-16-interactive-flat-panels'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/VDF38bpoKOFgKqltA0PANnVkfB9WHWpNJHjf7RvW.jpg',
            title: 'One Platform for Students, Teachers, Parents & Management — Why It Works',
            summary: 'Discover how Virsa school ERP and LMS system connects students, teachers, parents, and management on one platform with AI-powered learning, tracking, and analytics.',
            link: '/blog/one-platform-school-erp-lms-system-virsa'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/0UxxZ7pSr6ouj9Br6nyzXX3bxW8TRMF96hvO8e5Z.jpg',
            title: 'The Hidden Cost of Panel Damage in Schools & How to Avoid It | Virsa',
            summary: 'Discover the hidden costs of interactive panel damage in schools and how Virsa IFP sliding shutters protect your investment and reduce maintenance expenses.',
            link: '/blog/hidden-cost-of-panel-damage-schools'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/BYVFIoKS5uaVHTDJ7rHHA2fvewTg3mwBeiq3mdyK.jpg',
            title: 'How Interactive Panels Improve Student Engagement & Learning Outcomes | Virsa',
            summary: 'Discover the benefits of interactive panels in education. Improve student engagement and learning outcomes with Virsa smart classroom solutions and digital K-12 content.',
            link: '/blog/interactive-panels-improve-student-engagement-learning-outcomes'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/TQQzzUwkZMywaDpoOvCiqFG8sOGAVC4SMpPHCwPd.jpg',
            title: 'How Visual Learning Improves Retention and Exam Performance | Virsa digital K-12 Content',
            summary: 'Discover how visual learning improves student retention and exam results. Upgrade your school with Virsa smart classroom solution and interactive flat panels.',
            link: '/blog/how-visual-learning-improves-retention-and-exam-performance'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/64by4Z3lsq5Xj0wMqkdQSVZmxuh2yjmQjfMW9oXR.jpg', // Placeholder as requested
            title: 'Best Interactive Flat Panels for Schools, Colleges & Offices | Virsa Interactive Flat Panels',
            summary: 'Discover the best interactive flat panels for schools, colleges, offices, and training centers. Buy Virsa IFP (55” to 110”) with 4K display and smart features.',
            link: '/blog/best-interactive-flat-panels-virsa-ifp'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/TXladZpG98WSmcy2LB77EGjW4jYcHI4LgH6O4r8x.jpg', // Placeholder
            title: 'AI-Powered LMS for Schools | Next-Gen Personalized Learning by Virsa',
            summary: 'Discover Virsa AI-powered LMS with personalized learning, AI tutoring, automated assessments, real-time analytics, and smart classroom integration for modern education.',
            link: '/blog/ai-powered-lms-for-schools'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/kMWqXdwLiEdcKQYoPwsvWtH1sFDNw2EUuSSH5tyl.jpg', // Placeholder
            title: 'Projector vs Interactive Flat Panel: What Schools Should Choose in 2026 | Virsa',
            summary: 'Compare projectors vs interactive flat panels for schools. Discover which is better for smart classrooms, digital learning, and long-term performance with Virsa solutions.',
            link: '/blog/projector-vs-interactive-flat-panel'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/GY3q8To7wi6zYAxLOIUAzAthCa3mG41UaT2vsbY3.jpg', // Placeholder
            title: 'K–12 Digital Content for Schools | Interactive Learning Solutions by Virsa',
            summary: 'Explore Virsa K–12 digital content covering Science, Maths, English, SST, Physics, Chemistry, and Biology with interactive learning, better results, and improved retention.',
            link: '/blog/k12-digital-content-for-schools'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/ACh0aK2MrNaEnLSifGPZMaIpWAiCUAbuZSo3IPiq.jpg',
            title: 'Why All-in-One PCs Are Ideal for Computer Labs and Offices | Virsa',
            summary: 'Discover why All-in-One PCs are the best choice for computer labs, schools, and offices. Learn the benefits and features of Virsa All-in-One PCs for modern workspaces.',
            link: '/blog/all-in-one-pcs-for-computer-labs-and-offices'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/xrFbOXPJTYs0zlSF8JQkYMG59oNHpAj22AADIQtN.jpg', // Placeholder
            title: 'Complete Protection Guide: Dust, Impact, and Safety for Smart Panels | Virsa',
            summary: 'Protect interactive smart panels from dust, impact, and damage with heavy-duty protection shutters.',
            link: '/blog/smart-panel-protection-guide-ifp-shutter'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/6Vv9Ld9BPUqZZeiaChplhltnwONWH5NJffTwuDDp.jpg', // Placeholder
            title: 'Best LMS for Schools in India | Unified Learning Management System',
            summary: 'Discover how a unified Learning Management System connects students, teachers, parents & management on one powerful platform.',
            link: '/blog/best-lms-for-schools-in-india-unified-learning-management-system'
        },

        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/zJhcJwLSJ6IhgldFnM13nWRNibYPr1yiVQQV0eSu.jpg', // Placeholder
            title: 'Why Protection Matters: Extending the Life of Your Interactive Panels',
            summary: 'Learn how to extend the life of Interactive Flat Panels with proper protection and maintenance.',
            link: '/blog/why-protection-matters-extending-the-life-of-your-interactive-flat-panels'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/PVXZGISFoTDhykDWQUjjagtvQqwZCvAPWOFxJ0LF.jpg', // Placeholder
            title: 'Common Mistakes Schools Make While Buying Interactive Flat Panels',
            summary: 'Learn common buying mistakes and why schools trust Virsa for smart classroom solutions.',
            link: '/blog/common-mistakes-schools-make-while-buying-interactive-flat-panels-ifp'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/VWAckOV3dmTQDlzJxTwbu0OWEYqeRUvaa7s6vDv5.jpg', // Placeholder
            title: 'Digital Content for K-12 – Why It Matters',
            summary: 'The importance of high-quality digital resources in early education.',
            link: '/blog/digital-content-k12'
        },
        {
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/611LkwPzzru6GXTpGb7S2aQED8xbiR6pmacw6dwo.jpg', // Placeholder
            title: 'Choosing the Right Interactive Flat Panel for Your School',
            summary: 'Key factors to consider when investing in classroom display technology.',
            link: '/blog/choosing-the-right-interactive-flat-panel-for-your-school'
        },

    ];

    caseStudies = [
        {
            image: 'assets/images/home/home-banner.png', // Placeholder
            schoolName: 'Delhi Private School',
            details: '50 Interactive Panels Installed',
            summary: 'Problem: Outdated projectors. Solution: IFP upgrade. Result: 40% increase in engagement.',
            link: '#'
        },
        {
            image: 'assets/images/home/home-banner.png', // Placeholder
            schoolName: 'State Govt ICT Project',
            details: '200+ Classrooms Digitized',
            summary: 'Problem: Rural access. Solution: Smart classrooms. Result: Standardized education across districts.',
            link: '#'
        },
        {
            image: 'assets/images/home/home-banner.png', // Placeholder
            schoolName: 'Coaching Institute Chain',
            details: 'LMS Result Improvement',
            summary: 'Problem: Tracking progress. Solution: Custom LMS. Result: Better performance analytics.',
            link: '#'
        }
    ];

    brochures = [
        { icon: 'monitor', title: 'Interactive Flat Panels', description: 'Specs for 65", 75", 86" panels.', link: 'assets/pdf/ifp-panel.pdf', fileName: 'ifp-panel.pdf' },
        { icon: 'computer', title: 'All-in-One PCs', description: 'Powerful all-in-one computing for modern classrooms.', link: 'assets/pdf/all-in-one-pc.pdf', fileName: 'all-in-one-pc.pdf' },
        { icon: 'security', title: 'IFP Protection Sliding Shutters', description: 'Durable shutter solutions to protect interactive panels.', link: 'assets/pdf/shutter.pdf', fileName: 'shutter.pdf' },
        { icon: 'menu_book', title: 'K–12 Digital Content', description: 'List of animated subjects for engaging digital learning.', link: 'assets/pdf/k-12.pdf', fileName: 'k-12-digital-content.pdf' },
        { icon: 'palette', title: 'Learning Management System (LMS)', description: 'Features and capabilities of our learning platform.', link: 'assets/pdf/lms.pdf', fileName: 'lms.pdf' }
    ];

    videos = [
        { thumbnail: 'assets/images/home/home-banner.png', title: 'Interactive Flat Panel Demo', link: '#' },
        { thumbnail: 'assets/images/home/home-banner.png', title: 'LMS Platform Walkthrough', link: '#' },
        { thumbnail: 'assets/images/home/home-banner.png', title: 'K-12 Content Sample', link: '#' },
        { thumbnail: 'assets/images/home/home-banner.png', title: 'Installation Showcase', link: '#' },
        { thumbnail: 'assets/images/home/home-banner.png', title: 'Client Testimonial Videos', link: '#' }
    ];

    blogArticles: any[] = [];
    currentPage = 1;
    pageSize = 9;
    totalPages = 0;
    pagesArray: number[] = [];

    constructor() { }

    ngOnInit(): void {
        this.totalPages = Math.ceil(this.allBlogArticles.length / this.pageSize);
        this.pagesArray = Array.from({ length: this.totalPages }, (_, i) => i + 1);
        this.updatePaginatedArticles();
    }

    updatePaginatedArticles(): void {
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        this.blogArticles = this.allBlogArticles.slice(startIndex, endIndex);
    }

    goToPage(page: number): void {
        if (page >= 1 && page <= this.totalPages) {
            this.currentPage = page;
            this.updatePaginatedArticles();
            this.scrollToBlogSection();
        }
    }

    nextPage(): void {
        if (this.currentPage < this.totalPages) {
            this.goToPage(this.currentPage + 1);
        }
    }

    prevPage(): void {
        if (this.currentPage > 1) {
            this.goToPage(this.currentPage - 1);
        }
    }

    scrollToBlogSection(): void {
        const element = document.querySelector('.blog-section');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }


}
